import { render, staticRenderFns } from "./edit-issue.vue?vue&type=template&id=37d3c4b4&scoped=true"
import script from "./edit-issue.vue?vue&type=script&lang=js"
export * from "./edit-issue.vue?vue&type=script&lang=js"
import style0 from "./edit-issue.vue?vue&type=style&index=0&id=37d3c4b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d3c4b4",
  null
  
)

export default component.exports